import { isClient } from "@kikoff/utils/src/general";

// Dont include in dev env. Running cypress locally is impacted by GTM scripts when they dont load and fail.
if (isClient && process.env.REALLY_PRODUCTION) {
  // @ts-expect-error
  // eslint-disable-next-line
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://proxy.csidetm.com/https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KZDXSSZ');
}
